import { GetCompanyThresholdMeta, GetCompanyThresholdPayload } from 'types/store/GetCompanyThreshold';
import { createAsyncReducer } from 'utils/Redux';

import { getCompanyThresholdActions } from '../actions';

export default createAsyncReducer<GetCompanyThresholdMeta, GetCompanyThresholdPayload>(getCompanyThresholdActions);
